import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ObserversModule } from '@angular/cdk/observers';

import { PhxBreadcrumbComponent } from './phx-breadcrumb.component';
import { PhxBreadcrumbItemComponent } from './breadcrumb-item/phx-breadcrumb-item.component';
import { PhxBadgeModule } from '../badge/phx-badge.module';
import { PhxTooltipModule } from '../tooltip/phx-tooltip.module';

@NgModule({
  declarations: [PhxBreadcrumbComponent, PhxBreadcrumbItemComponent],
  imports: [CommonModule, RouterModule, PhxBadgeModule, PhxTooltipModule, ObserversModule],
  exports: [PhxBreadcrumbComponent, PhxBreadcrumbItemComponent],
})
export class PhxBreadcrumbModule {}
